// extracted by mini-css-extract-plugin
export default {"menuItem":"BaseOverlayMenuListItem_menuItem_r2Yfy","menuItemLink":"BaseOverlayMenuListItem_menuItemLink_Wf2QR"};